var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error-container"}},[_c('v-alert',{staticClass:"text-center",attrs:{"prominent":"","type":"error"}},[_vm._v(" There was a problem loading the component ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }